var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00A68B",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_8897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 13.3335H17.5L19.1667 17.5002L17.0833 18.7502C17.9758 20.5598 19.4404 22.0244 21.25 22.9168L22.5 20.8335L26.6667 22.5002V25.8335C26.6667 26.2755 26.4911 26.6994 26.1785 27.012C25.866 27.3246 25.442 27.5002 25 27.5002C21.7494 27.3026 18.6835 25.9222 16.3807 23.6195C14.0779 21.3167 12.6975 18.2508 12.5 15.0002C12.5 14.5581 12.6756 14.1342 12.9882 13.8217C13.3007 13.5091 13.7246 13.3335 14.1667 13.3335Z",
    stroke: "#00A68B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_8897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallOutlined);
export default __webpack_public_path__ + "static/media/callOutlined.a787c8b6.svg";
export { ForwardRef as ReactComponent };